import React from 'react';
import './CredentialsPicker.css';

const LEVEL_LABEL = { partner: 'Partner', account: 'Chain', hotel: 'Hotel' };

// Collapsed display of a selected credential — name + level badge + Change/Remove.
// Shared across sync, payment porter and vault so the chip is identical everywhere.
// Props:
//   name      — credential name
//   level     — 'partner' | 'account' | 'hotel'
//   meta      — optional secondary text (e.g. "Hotel ID: LONHILTON")
//   onChange  — optional, fired when Change is clicked
//   onRemove  — optional, fired when Remove is clicked
//   busy      — disables the buttons while an action is in flight
export default function CredentialChip({ name, level, meta, onChange, onRemove, busy }) {
    return (
        <div className="cred-selected">
            <div className="cred-selected-info">
                <span className="cred-selected-name">{name}</span>
                {level && <span className={`cred-picker-row-level cred-level-${level}`}>{LEVEL_LABEL[level] || level}</span>}
                {meta && <span className="cred-selected-meta">{meta}</span>}
            </div>
            <div className="cred-selected-actions">
                {onChange && (
                    <button type="button" className="cred-selected-change" onClick={onChange} disabled={busy}>Change</button>
                )}
                {onRemove && (
                    <button type="button" className="cred-selected-remove" onClick={onRemove} disabled={busy}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                        Remove
                    </button>
                )}
            </div>
        </div>
    );
}
